export function XDivider() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1396"
      height="6"
      viewBox="0 0 1396 6"
      fill="none"
    >
      <path
        d="M1395.89 3L1393 0.113249L1390.11 3L1393 5.88675L1395.89 3ZM0.113159 3.00012L2.99988 5.88687L5.88672 3.00012L2.99988 0.11337L0.113159 3.00012ZM1393 2.5L2.99988 2.50012L2.99988 3.50012L1393 3.5L1393 2.5Z"
        fill="white"
        fillOpacity="0.2"
      />
    </svg>
  )
}
